const Data = [
    {
      id: 1,
      rating: 10,
      text: 'this is the first feedback for this app.',
    },
    {
      id: 2,
      rating: 9,
      text: 'This is the second feedback for this app.',
    },
    {
      id: 3,
      rating: 8,
      text: 'This is a good app if you like it, pls share.',
    },
  ]
  
  export default Data